/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import activityLogTemplate from './activity-log.tpl.html'

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ActivityLogRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.activityLogs', {
            url: '/activityLogs',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value,
                   types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value,
                   types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
                   types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value,
                ],
            views: {
                "content@home": {
                    templateUrl: activityLogTemplate,
                    controllerAs: 'vm',
                    controller: 'ActivityLogController'
                }
            },
            data: {
                pageTitle: 'activity-log.activity-logs'
            },
            ncyBreadcrumb: {
                label: '{"icon": "donut_large", "label": "activity-log.activity-logs"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/activity-log/activity-log.routes.js